import type { CSSProperties } from 'react';
import type { Theme } from '@mui/material/styles';

/** Recharts tooltip panel — matches gauge / graph card surface per theme. */
export function getIuChartTooltipContentStyle(theme: Theme): CSSProperties {
  const dash = theme.palette.dashboard;
  if (dash?.gaugePanelBackgroundColor) {
    return {
      backgroundColor: dash.gaugePanelBackgroundColor,
      color: dash.gaugePanelTextColor ?? theme.palette.text.primary,
      border: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : theme.palette.grey[300]
      }`,
      borderRadius: 8,
    };
  }
  if (theme.palette.mode === 'dark') {
    return {
      backgroundColor: 'rgb(20, 25, 55)',
      color: theme.palette.text.primary,
      borderRadius: 8,
    };
  }
  return { borderRadius: 8 };
}

/**
 * PROFESSIONAL LIGHT: secondary-series lines (WhatsApp, Blocked, Read, etc.) use dark grey.
 * Other themes: keep the palette token passed in.
 */
export function getIuChartAccentSeriesColor(theme: Theme, defaultColor: string): string {
  if (
    theme.palette.dashboard?.gaugePanelBackgroundColor
    && theme.palette.mode === 'light'
  ) {
    return 'rgb(25, 25, 25)';
  }
  return defaultColor;
}

/** Area fill paired with {@link getIuChartAccentSeriesColor}. */
export function getIuChartAccentSeriesFill(theme: Theme, defaultFill: string): string {
  if (
    theme.palette.dashboard?.gaugePanelBackgroundColor
    && theme.palette.mode === 'light'
  ) {
    return 'rgba(25, 25, 25, 0.18)';
  }
  return defaultFill;
}
